<template lang='pug'>
.custom-scrollbar(:class='[$style[`cc-notify-board-container`], $style[!passData.length ? `mode-warn` : ``]]')
  div(v-if='passData.length' :class='$style[`cc-notify-board-list`]')
    //- Search Person result
    div(:class='$style[`cc-notify-board-topic`]')
      span!= '新通知'
      span(:class='$style[`cc-notify-board-topic-clean`]' @click='handleClickClearAllNotify')!= '清除全部'
    div(v-for='(item, key) in dataContainer' :key='item.key' :class='$style[`cc-notify-board-nav`]')
      template(v-if='item.remind === `yes`')
        //- QA獲得推薦
        router-link(
          v-if='item.behavior === `qa-agree`'
          role='button'
          tabindex='0'
          aria-label='查看內容'
          :to='{ name: `qa-detail`, params: { quesId: `${item.category_id}` }}'
          :class='$style[`cc-notify-board-sub-content`]'
          @click.native='handleClickClearPerNotify(item.category, item.auth_id, item.category_id, item.remind_user_id, item.behavior)')
          div(:class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/doctor_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/doctor_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(:class='$style[`cc-notify-board-person-info`]')
                strong
                  span.font-doctor-theme {{ `${item.firstName}${item.lastName}`}}
                != '給予你的'
                strong!= '提問'
                span.font-doctor-theme
                  IconAgree(:size='18' :color='`#009fa5`')
                  != '推薦'
                != '。'
              div(:class='$style[`cc-notify-board-time`]') {{ item.date }}


        //- QA獲得讚
        router-link(
          v-if='item.behavior === `qa-like`'
          role='button'
          tabindex='0'
          aria-label='查看內容'
          :to='{ name: `qa-detail`, params: { quesId: `${item.category_id}` }}'
          :class='$style[`cc-notify-board-sub-content`]'
          @click.native='handleClickClearPerNotify(item.category, item.auth_id, item.category_id, item.remind_user_id, item.behavior)')
          div(:class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(:class='$style[`cc-notify-board-person-info`]')
                strong(v-if='!item.lastName')
                  span.font-normal-theme {{ `${item.firstName}${item.gender === '0' ? `先生` : `小姐`}`}}
                strong(v-else)
                  span.font-normal-theme {{ `${item.firstName}${item.lastName}`}}
                != '覺得你的'
                strong!= '提問'
                span.font-normal-theme
                  IconLike(:size='18' :color='`#ef6357`')
                  != '讚'
                != '。'
              div(:class='$style[`cc-notify-board-time`]') {{ item.date }}

        //- Resume獲得推薦
        router-link(
          v-if='item.behavior === `resume-agree`'
          role='button'
          tabindex='0'
          aria-label='查看內容'
          :to='{ name: `profile-resume`, params: { type: `normal`, id: `${item.category_id}` } }'
          :class='$style[`cc-notify-board-sub-content`]'
          @click.native='handleClickClearPerNotify(item.category, item.auth_id, item.category_id, item.remind_user_id, item.behavior)')
          div(:class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/doctor_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/doctor_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(:class='$style[`cc-notify-board-person-info`]')
                strong
                  span.font-doctor-theme {{ `${item.firstName}${item.lastName}`}}
                != '給予你的'
                strong!= '故事卡'
                span.font-doctor-theme
                  IconAgree(:size='18' :color='`#009fa5`')
                  != '推薦'
                != '。'
              div(:class='$style[`cc-notify-board-time`]') {{ item.date }}

        //- Resume獲得讚
        router-link(
          v-if='item.behavior === `resume-like`'
          role='button'
          tabindex='0'
          aria-label='查看內容'
          :to='{ name: `profile-resume`, params: { type: `normal`, id: `${item.category_id}` } }'
          :class='$style[`cc-notify-board-sub-content`]'
          @click.native='handleClickClearPerNotify(item.category, item.auth_id, item.category_id, item.remind_user_id, item.behavior)')
          div(:class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(:class='$style[`cc-notify-board-person-info`]')
                strong(v-if='!item.lastName')
                  span.font-normal-theme {{ `${item.firstName}${item.gender === '0' ? `先生` : `小姐`}`}}
                strong(v-else)
                  span.font-normal-theme {{ `${item.firstName}${item.lastName}`}}
                != '覺得你的'
                strong!= '故事卡'
                span.font-normal-theme
                  IconLike(:size='18' :color='`#ef6357`')
                  != '讚'
                != '。'
              div(:class='$style[`cc-notify-board-time`]') {{ item.date }}


        //- QA有人留言
        router-link(
          v-if='item.behavior === `qa-reply`'
          role='button'
          tabindex='0'
          aria-label='查看內容'
          :to='{ name: `qa-detail`, params: { quesId: `${item.category_id}` }}'
          :class='$style[`cc-notify-board-sub-content`]'
          @click.native='handleClickClearPerNotify(item.category, item.auth_id, item.category_id, item.remind_user_id, item.behavior)')
          div(v-if='item.user_type === `doctor`' :class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/doctor_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/doctor_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(:class='$style[`cc-notify-board-person-info`]')
                strong
                  span.font-doctor-theme {{ `${item.firstName}${item.lastName}`}}
                != '在你的'
                strong!= '提問'
                != '中'
                span
                  IconDialog(:size='18' :color='`#b1b1b1`')
                  != '留言'
                != '。'
              div(:class='$style[`cc-notify-board-time`]') {{ item.date }}

          div(v-if='item.user_type === `normal`' :class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(:class='$style[`cc-notify-board-person-info`]')
                strong(v-if='!item.lastName')
                  span.font-normal-theme {{ `${item.firstName}${item.gender === '0' ? `先生` : `小姐`}`}}
                strong(v-else)
                  span.font-normal-theme {{ `${item.firstName}${item.lastName}`}}
                != '在你的'
                strong!= '提問'
                != '中'
                span
                  IconDialog(:size='18' :color='`#b1b1b1`')
                  != '留言'
                != '。'
              div(:class='$style[`cc-notify-board-time`]') {{ item.date }}


        //- 故事卡有人送祝福
        router-link(
          v-if='item.behavior === `resume-bless`'
          role='button'
          tabindex='0'
          aria-label='查看內容'
          :to='{ name: `profile-resume`, params: { type: `normal`, id: `${item.category_id}` } }'
          :class='$style[`cc-notify-board-sub-content`]'
          @click.native='handleClickClearPerNotify(item.category, item.auth_id, item.category_id, item.remind_user_id, item.behavior)')
          div(v-if='item.user_type === `doctor`' :class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/doctor_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/doctor_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(:class='$style[`cc-notify-board-person-info`]')
                strong
                  span.font-doctor-theme {{ `${item.firstName}${item.lastName}`}}
                != '在你的'
                strong!= '故事卡'
                != '留下'
                span(style='color: #dc4c5e;')
                  IconBless(:size='18')
                  != '祝福'
                != '。'
              div(:class='$style[`cc-notify-board-time`]') {{ item.date }}

          div(v-if='item.user_type === `normal`' :class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(:class='$style[`cc-notify-board-person-info`]')
                strong(v-if='!item.lastName')
                  span.font-normal-theme {{ `${item.firstName}${item.gender === '0' ? `先生` : `小姐`}`}}
                strong(v-else)
                  span.font-normal-theme {{ `${item.firstName}${item.lastName}`}}
                != '在你的'
                strong!= '故事卡'
                != '留下'
                span(style='color: #dc4c5e;')
                  IconBless(:size='18')
                  != '祝福'
                != '。'
              div(:class='$style[`cc-notify-board-time`]') {{ item.date }}


        //- 民眾追蹤醫師
        router-link(
          v-if='item.behavior === `new-follower`'
          role='button'
          tabindex='0'
          aria-label='查看內容'
          :to='{ name: `profile-detail`, params: { type: `normal`, id: `${item.auth_id}` } }'
          :class='$style[`cc-notify-board-sub-content`]'
          @click.native='handleClickClearPerNotify(item.category, item.auth_id, item.category_id, item.remind_user_id, item.behavior)')
          div(:class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(:class='$style[`cc-notify-board-person-info`]')
                strong(v-if='!item.lastName')
                  span.font-normal-theme {{ `${item.firstName}${item.gender === '0' ? `先生` : `小姐`}`}}
                strong(v-else)
                  span.font-normal-theme {{ `${item.firstName}${item.lastName}`}}
                != '追蹤了你。'

              div(:class='$style[`cc-notify-board-time`]') {{ item.date }}


        //- 嚴重通知
        div(v-if='item.behavior === `se_fever`' :class='$style[`cc-notify-board-sub-content`]' @click='handleClickClearPerNotify(item.category, item.auth_id, item.category_id, item.remind_user_id, item.behavior)')
          div(:class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(v-if='item.auth_id === `${loginDjangoId}`' :class='$style[`cc-notify-board-person-info`]')
                != '我的記錄，發燒超過38度'
              div(v-else :class='$style[`cc-notify-board-person-info`]')
                strong(v-if='!item.lastName')
                  span.font-normal-theme {{ `${item.firstName}${item.gender === '0' ? `先生` : `小姐`}`}}
                strong(v-else)
                  span.font-normal-theme {{ `${item.firstName}${item.lastName}`}}
                != '的記錄，發燒超過38度'


        //- 嚴重通知
        div(v-if='item.behavior === `se_painlevel`' :class='$style[`cc-notify-board-sub-content`]' @click='handleClickClearPerNotify(item.category, item.auth_id, item.category_id, item.remind_user_id, item.behavior)')
          div(:class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(v-if='item.auth_id === `${loginDjangoId}`' :class='$style[`cc-notify-board-person-info`]')
                != '我的記錄，疼痛等級過高'
              div(v-else :class='$style[`cc-notify-board-person-info`]')
                strong(v-if='!item.lastName')
                  span.font-normal-theme {{ `${item.firstName}${item.gender === '0' ? `先生` : `小姐`}`}}
                strong(v-else)
                  span.font-normal-theme {{ `${item.firstName}${item.lastName}`}}
                != '的記錄，疼痛等級過高'


        //- 嚴重通知
        div(v-if='item.behavior === `se_nausea`' :class='$style[`cc-notify-board-sub-content`]' @click='handleClickClearPerNotify(item.category, item.auth_id, item.category_id, item.remind_user_id, item.behavior)')
          div(:class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(v-if='item.auth_id === `${loginDjangoId}`' :class='$style[`cc-notify-board-person-info`]')
                != '我的記錄，嘔吐程度嚴重'
              div(v-else :class='$style[`cc-notify-board-person-info`]')
                strong(v-if='!item.lastName')
                  span.font-normal-theme {{ `${item.firstName}${item.gender === '0' ? `先生` : `小姐`}`}}
                strong(v-else)
                  span.font-normal-theme {{ `${item.firstName}${item.lastName}`}}
                != '的記錄，嘔吐程度嚴重'


        //- 嚴重通知
        div(v-if='item.behavior === `se_pant`' :class='$style[`cc-notify-board-sub-content`]' @click='handleClickClearPerNotify(item.category, item.auth_id, item.category_id, item.remind_user_id, item.behavior)')
          div(:class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(v-if='item.auth_id === `${loginDjangoId}`' :class='$style[`cc-notify-board-person-info`]')
                != '我的記錄，喘氣程度嚴重'
              div(v-else :class='$style[`cc-notify-board-person-info`]')
                strong(v-if='!item.lastName')
                  span.font-normal-theme {{ `${item.firstName}${item.gender === '0' ? `先生` : `小姐`}`}}
                strong(v-else)
                  span.font-normal-theme {{ `${item.firstName}${item.lastName}`}}
                != '的記錄，喘氣程度嚴重'

        //- 嚴重通知
        div(v-if='item.behavior === `se_diarrhea`' :class='$style[`cc-notify-board-sub-content`]' @click='handleClickClearPerNotify(item.category, item.auth_id, item.category_id, item.remind_user_id, item.behavior)')
          div(:class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(v-if='item.auth_id === `${loginDjangoId}`' :class='$style[`cc-notify-board-person-info`]')
                != '我的記錄，腹瀉程度嚴重'
              div(v-else :class='$style[`cc-notify-board-person-info`]')
                strong(v-if='!item.lastName')
                  span.font-normal-theme {{ `${item.firstName}${item.gender === '0' ? `先生` : `小姐`}`}}
                strong(v-else)
                  span.font-normal-theme {{ `${item.firstName}${item.lastName}`}}
                != '的記錄，腹瀉程度嚴重'


        //- 嚴重通知
        div(v-if='item.behavior === `se_weight_2`' :class='$style[`cc-notify-board-sub-content`]' @click='handleClickClearPerNotify(item.category, item.auth_id, item.category_id, item.remind_user_id, item.behavior)')
          div(:class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(v-if='item.auth_id === `${loginDjangoId}`' :class='$style[`cc-notify-board-person-info`]')
                != '我的記錄，體重減輕(-2%)'
              div(v-else :class='$style[`cc-notify-board-person-info`]')
                strong(v-if='!item.lastName')
                  span.font-normal-theme {{ `${item.firstName}${item.gender === '0' ? `先生` : `小姐`}`}}
                strong(v-else)
                  span.font-normal-theme {{ `${item.firstName}${item.lastName}`}}
                != '的記錄，體重減輕(-2%)'

        //- 嚴重通知
        div(v-if='item.behavior === `se_weight_3`' :class='$style[`cc-notify-board-sub-content`]' @click='handleClickClearPerNotify(item.category, item.auth_id, item.category_id, item.remind_user_id, item.behavior)')
          div(:class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(v-if='item.auth_id === `${loginDjangoId}`' :class='$style[`cc-notify-board-person-info`]')
                != '我的記錄，體重減輕(-3%)'
              div(v-else :class='$style[`cc-notify-board-person-info`]')
                strong(v-if='!item.lastName')
                  span.font-normal-theme {{ `${item.firstName}${item.gender === '0' ? `先生` : `小姐`}`}}
                strong(v-else)
                  span.font-normal-theme {{ `${item.firstName}${item.lastName}`}}
                != '的記錄，體重減輕(-3%)'


        //- 嚴重通知
        div(v-if='item.behavior === `se_weight_4`' :class='$style[`cc-notify-board-sub-content`]' @click='handleClickClearPerNotify(item.category, item.auth_id, item.category_id, item.remind_user_id, item.behavior)')
          div(:class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(v-if='item.auth_id === `${loginDjangoId}`' :class='$style[`cc-notify-board-person-info`]')
                != '我的記錄，體重減輕(-4%)'
              div(v-else :class='$style[`cc-notify-board-person-info`]')
                strong(v-if='!item.lastName')
                  span.font-normal-theme {{ `${item.firstName}${item.gender === '0' ? `先生` : `小姐`}`}}
                strong(v-else)
                  span.font-normal-theme {{ `${item.firstName}${item.lastName}`}}
                != '的記錄，體重減輕(-4%)'


        //- 嚴重通知
        div(v-if='item.behavior === `se_weight_5`' :class='$style[`cc-notify-board-sub-content`]' @click='handleClickClearPerNotify(item.category, item.auth_id, item.category_id, item.remind_user_id, item.behavior)')
          div(:class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(v-if='item.auth_id === `${loginDjangoId}`' :class='$style[`cc-notify-board-person-info`]')
                != '我的記錄，體重減輕(-5%)'
              div(v-else :class='$style[`cc-notify-board-person-info`]')
                strong(v-if='!item.lastName')
                  span.font-normal-theme {{ `${item.firstName}${item.gender === '0' ? `先生` : `小姐`}`}}
                strong(v-else)
                  span.font-normal-theme {{ `${item.firstName}${item.lastName}`}}
                != '的記錄，體重減輕(-5%)'


        //- 嚴重通知
        div(v-if='item.behavior === `se_weight_6`' :class='$style[`cc-notify-board-sub-content`]' @click='handleClickClearPerNotify(item.category, item.auth_id, item.category_id, item.remind_user_id, item.behavior)')
          div(:class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(v-if='item.auth_id === `${loginDjangoId}`' :class='$style[`cc-notify-board-person-info`]')
                != '我的記錄，體重減輕(-6%)'
              div(v-else :class='$style[`cc-notify-board-person-info`]')
                strong(v-if='!item.lastName')
                  span.font-normal-theme {{ `${item.firstName}${item.gender === '0' ? `先生` : `小姐`}`}}
                strong(v-else)
                  span.font-normal-theme {{ `${item.firstName}${item.lastName}`}}
                != '的記錄，體重減輕(-6%)'


        //- 嚴重通知
        div(v-if='item.behavior === `se_weight_7`' :class='$style[`cc-notify-board-sub-content`]' @click='handleClickClearPerNotify(item.category, item.auth_id, item.category_id, item.remind_user_id, item.behavior)')
          div(:class='$style[`cc-notify-board-caption`]')
            figure(v-if='!item.thumbSrc' :class='$style[`cc-board-caption-tb`]')
              img(
                v-if='item.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-board-caption-tb`]')
              img(
                :src='avatarSrcLink(item.thumbSrc)'
                width='100%'
                height='100%')

            div(:class='$style[`cc-notify-board-person-main`]')
              div(v-if='item.auth_id === `${loginDjangoId}`' :class='$style[`cc-notify-board-person-info`]')
                != '我的記錄，體重減輕(-7%)'
              div(v-else :class='$style[`cc-notify-board-person-info`]')
                strong(v-if='!item.lastName')
                  span.font-normal-theme {{ `${item.firstName}${item.gender === '0' ? `先生` : `小姐`}`}}
                strong(v-else)
                  span.font-normal-theme {{ `${item.firstName}${item.lastName}`}}
                != '的記錄，體重減輕(-7%)'



    div(v-if='loadedComplete' :class='$style[`cc-notify-lazyload-wrap`]')
      infinite-loading(:class='$style[`cc-content-infinite-load`]' :identifier='infiniteId' @infinite='infiniteHandler')
        IconLoading(slot='spinner' :size='30' :color='`#b1b1b1`')
        div.infinite-scroll-slot(slot='no-more')
          span.infinite-scroll-slot-noMore {{ '沒有更多通知' }}

        div.infinite-scroll-slot(slot='no-results')
          span.infinite-scroll-slot-noMore {{ '沒有更多通知' }}

  //- Mode-Warn
  div(v-else :class='$style[`cc-notify-board-warn`]')
    span!= '沒有新的通知'


</template>

<script>
import { mapGetters, mapActions } from 'vuex';

// import CustomScrollbar from 'perfect-scrollbar';
import IconAgree from '../../icon/Agree';
import IconLike from '../../icon/Like';
import IconBless from '../../icon/Bless';
import IconDialog from '../../icon/Dialog';
import IconLoading from '../../icon/Loading';

import {
  // getUserNotifyList,
  deleteAllNotifyRead,
  putUserNotifyRead,
} from '../../../js/restapi';

export default {
  components: {
    IconLike,
    IconAgree,
    IconBless,
    IconDialog,
    IconLoading,
  },

  props: {
    loadedComplete: {
      type: Boolean,
      default: false,
    },
    passData: {
      type: Array,
      required: true,
      default: null,
    },
  },

  data() {
    return {
      limitCount: 12,
      pageIndex: 2,
      dataContainer: [],
      infiniteId: new Date(),
    };
  },

  created() {
    this.dataContainer = this.passData;
  },

  // mounted() {
  //   const refScrollBar = this.$refs.customScrollBarDom;
  //   const ps = new CustomScrollbar(refScrollBar);
  // },

  methods: {
    ...mapActions({
      changeNotify: 'user/changeTopBarNotifyFocus',
    }),

    // infiniteHandler($state) {
    //   if (this.loadedComplete) {
    //     getUserNotifyList(`/?pk=${this.loginDjangoId}&size=${this.limitCount}&page=${this.pageIndex}`)
    //       .then((res) => {
    //         const resData = res.data.results;
    //         if (!resData.length) {
    //           // this.loadedPreload = false;
    //           $state.complete();
    //           return;
    //         }

    //         const getLoadData = new Promise((resolve) => {
    //           resData.forEach((element) => {
    //             this.dataContainer.push(element);
    //           });
    //           return resolve(resData.length);
    //         });

    //         getLoadData.then((value) => {
    //           if (value >= this.limitCount) {
    //             this.pageIndex += 1;
    //             // this.loadedPreload = false;
    //             $state.loaded();
    //           } else {
    //             // this.loadedPreload = false;
    //             $state.complete();
    //           }
    //         });
    //       })
    //       .catch((err) => {
    //         console.log('err', err);
    //       });
    //   } else {
    //     // this.loadedPreload = false;
    //     $state.complete();
    //   }
    // },

    handleClickClearAllNotify() {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;
      console.log('刪除所有通知成功0！');

      deleteAllNotifyRead(`/?pk=${this.loginDjangoId}`, {
        headers: {
          'content-Type': 'application/json',
          // Authorization: `Bearer ${jwtAccess}`,
        },
      })
        .then((res) => {
          console.log('刪除所有通知成功1！');
          this.$emit('notifyReadUpdate');
          this.changeNotify(false);
        })
        .catch((err) => {
          console.log('刪除所有通知失敗！');
        });

      console.log('刪除所有通知成功2！');
    },

    handleClickClearPerNotify(category, auth_id, category_id, remind_user_id, behavior) {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;
      const PASS_DATA = {
        category,
        auth_id,
        category_id,
        remind_user_id,
        behavior,
      };
      // this.$emit('notifyReadUpdate');
      putUserNotifyRead('', PASS_DATA, {
        headers: {
          'content-Type': 'application/json',
          // Authorization: `Bearer ${jwtAccess}`,
        },
      })
        .then((res) => {
          console.log('刪除單一通知成功');
          this.$emit('notifyReadUpdate');
          this.changeNotify(false);
          if (category === 'sideeffect') {
            if (this.loginProfile.user_type === 'doctor') {
              window.location = `${this.SERVER_DOMAIN}/cms/subscriber/${auth_id}`;
            } else {
              this.$router.push({
                path: `/sideeffect/record?r=${category_id}`,
              }).catch(() => true);
            }
          }
        })
        .catch((err) => {
          console.log('刪除單一通知失敗！');
        });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      // stateTopBar: 'user/exportTopBarStatus',
      // loginStatus: 'user/exportLoginStatus',
      loginDjangoId: 'user/exportUserDjangoId',
      authJwtToken: 'user/exportUserJwtToken',
      loginProfile: 'user/exportUserProfile',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/topbar/boardNotify.scss';
</style>
